module.exports = __webpack_public_path__ + "static/media/Lev.579f4f08.jpg";